export enum HumanModerationStatus {
  A_MODERER = 'A_MODERER',
  MODERE = 'MODERE',
}
